export default __webpack_public_path__ + "static/media/mrker-dosug.b28500a8.svg";